import {
  Agree,
  Disagree,
  SomewhatAgree,
  SomewhatDisagree,
  StronglyAgree,
  StronglyDisagree,
} from "../../utils/Constant";
import P from "../Paragraph";
import StarRating from "../StarRating";

import "./style.scss";

const StarLikertScale = () => {
  const rateLevel = [
    StronglyDisagree,
    Disagree,
    SomewhatDisagree,
    SomewhatAgree,
    Agree,
    StronglyAgree,
  ];

  return (
    <table className="rate-level-table">
      <thead>
        <tr>
          {rateLevel.map((_, index) => (
            <th key={index}>
              <StarRating
                size={20}
                initialValue={1 + index}
                count={1 + index}
                disabled={true}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {rateLevel.map((item, index) => (
            <td key={index}>
              <div className="rate-level-table__mb-rating">
                <StarRating
                  size={20}
                  initialValue={1 + index}
                  count={1 + index}
                  disabled={true}
                />
              </div>
              <P>{item}</P>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

export default StarLikertScale;
